import { getLocale } from '../../utils/pathHelper';
import { baseTranslations, BaseTranslationKeys } from './baseTranslations';
import { yadoTranslations, YadoTranslationKeys } from './yadoTranslations';
import { insuranceTranslations, InsuranceTranslationKeys } from './insuranceTranslations';

export type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

type ITranslationFunction = {
  [key in BaseTranslationKeys|YadoTranslationKeys|InsuranceTranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

const locale: string = getLocale() || 'en';

const t: ITranslationFunction = {
  ...baseTranslations[locale],
  ...yadoTranslations[locale],
  ...insuranceTranslations[locale],
};

export default t;
